<template>
  <div class="tracking">
    <div class="map-wrapper">
      <div class="over-map-content">
        <actions-toolbar
          v-if="$vuetify.breakpoint.smAndUp"
          :focus.sync="focus"
          :vehicles="vehicles"
          :events="events"
          :loading="loading"
          @open-event-dialog="openEventDialog"
          @open-commands-dialog="openCommandsDialog"
        ></actions-toolbar>
      </div>
      <tracking-map :vehicles="vehicles" :focus="focus"></tracking-map>
    </div>
    <event-dialog ref="eventDialog"/>
    <commands-dialog ref="commandsDialog"/>
    <actions-toolbar
      v-if="$vuetify.breakpoint.xsOnly"
      :focus.sync="focus"
      :vehicles="vehicles"
      :events="events"
      :loading="loading"
      @open-event-dialog="openEventDialog"
    ></actions-toolbar>
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>

<script>
import ActionsToolbar from '../components/Tracking/ActionsToolbar'
import Map from '../components/Maps/Tracking'
import EventDialog from '../components/EventDialog'
import CommandsDialog from '../components/CommandsDialog'
import Snackbar from '../components/Snackbar'

export default {
  name: 'tracking',
  data: function () {
    return {
      focus: null,
      loading: false
    }
  },
  computed: {
    vehicles: function () {
      return this.$store.state.Tracking.vehicles
    },
    events: function () {
      return this.$store.getters['Tracking/events']
    }
  },
  watch: {
    focus: async function (focus) {
      if (!focus) return false
      try {
        await this.$store.dispatch('Tracking/watchVehicle', {
          vehicleId: focus
        })
        await this.$store.dispatch('Tracking/fetchVehicleLastEvent', {
          vehicleId: focus
        })
      } catch (e) {
        return this.$refs.snackbar.open('error', e.message)
      }
    }
  },
  components: {
    'actions-toolbar': ActionsToolbar,
    'tracking-map': Map,
    'event-dialog': EventDialog,
    'commands-dialog': CommandsDialog,
    'snackbar': Snackbar
  },
  created: async function () {
    this.loading = true
    try {
      await this.$store.dispatch('Tracking/connectToEventsServer')
      await this.$store.dispatch('Tracking/fetchVehicles')
      await this.$store.dispatch('Tracking/subscribeToEvents')
    } catch (e) {
      this.loading = false
      console.error(e)
      return this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor')
    }
    this.loading = false
    this.loadSettings()
  },
  destroyed: function () {
    this.$store.dispatch('Tracking/unsubscribeFromEvents')
    this.saveSettings()
  },
  methods: {
    openCommandsDialog: function ({ vehicleId }) {
      this.$refs.commandsDialog.open({ vehicleId })
    },
    openEventDialog: function (eventId) {
      this.$refs.eventDialog.open({ eventId })
    },
    loadSettings: function () {
      const username = localStorage.getItem('heimdall-session-username')
      if (process.env.NODE_ENV === 'development') {
        console.log(`Loading ${username} settings...`)
      }
      const settings = JSON.parse(localStorage.getItem(`heimdall-${username}-settings`))
      if (!settings) {
        return false
      }
      this.focus = settings.focus || null
    },
    saveSettings: function () {
      const username = localStorage.getItem('heimdall-session-username')
      if (process.env.NODE_ENV === 'development') {
        console.log(`Saving ${username} settings...`)
      }
      const unsavedSettings = {
        focus: this.focus
      }
      localStorage.setItem(`heimdall-${username}-settings`, JSON.stringify(unsavedSettings))
    }
  }
}
</script>

<style lang="sass" scoped>
$break-xs: 599px
$toolbar-height: 64px
$dense-toolbar-height: 56px
$map-height: calc(100vh - #{$toolbar-height})
$xs-map-height: calc(100vh - #{$dense-toolbar-height * 2})
.tracking
  height: 100%
  margin: 0
  padding: 0
.map-wrapper
  position: relative
.over-map-content
  position: absolute
  z-index: 1
.tracking-map
  height: $map-height
  @media screen and (max-width: $break-xs)
    height: $xs-map-height
  margin: 0
  padding: 0
</style>



// WEBPACK FOOTER //
// src/views/Tracking.vue